/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactResponseDtoSchema } from "../contactResponseDtoSchema";
import { createContactDtoSchema } from "../createContactDtoSchema";
import { z } from "zod/v4";

export const createContactHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

export const createContact201Schema = z.lazy(() => contactResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const createContact401Schema = z.any()

export const createContactMutationRequestSchema = z.lazy(() => createContactDtoSchema)

export const createContactMutationResponseSchema = z.lazy(() => createContact201Schema)